var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("客户登录统计"),
                      ]),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("统计时间:"),
                      ]),
                      _c("DatePicker", {
                        staticStyle: { "margin-left": "4px", width: "180px" },
                        attrs: {
                          type: "daterange",
                          value: _vm.selectDates,
                          size: "small",
                          transfer: "",
                          clearable: false,
                          placement: "bottom-end",
                          placeholder: "选择期初和期末时间",
                        },
                        on: { "on-change": _vm.onDateChange },
                      }),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("登录会员(去重):" + _vm._s(_vm.userLoginCount)),
                      ]),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("有采购的会员:" + _vm._s(_vm.userSaleCount)),
                      ]),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("采购比:" + _vm._s(_vm.saleLoginRate)),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "right-bar" }),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }